module.exports = __webpack_public_path__ + "static/media/Advance Compressor VR.a3f67ae.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/hd-racks/Advance Compressor VR.mp3
// module id = YFfo
// module chunks = 13